//////////////////////////////////////////////////////////////////////////////
//
//  API Registry (중앙 등록소)
//
//  작성자: MyungHwan Kim
//  생성일: 2025-10-24
//
//  설명: 모든 API 그룹을 하나로 모아서 NetworkManager에 등록
//
//////////////////////////////////////////////////////////////////////////////

import AuthenticationAPI from "./authentication"
import UserAPI from "./user"
import TenantAPI from "./tenant"
import AdvertiserAPI from "./advertiser"
import CommonCodeAPI from "./commonCode"
import { InterstitialAdAPI } from "./interstitialAd"
import { LoginHistoryAPI } from "./loginHistory"
import { DeviceAPI } from "./device"
import { PointPolicyAPI } from "./pointPolicy"
import { StepRecordAPI } from "./stepRecord"
import { PointBalanceAPI } from "./pointBalance"
import { PointTransactionAPI } from "./pointTransaction"
import { PointUseRequestAPI } from "./pointUseRequest"
import { AdViewLogAPI } from "./adViewLog"
import UserPointLimitPolicyAPI from "./userPointLimitPolicy"
import PointUsePolicyAPI from "./pointUsePolicy"
import ExerciseVideoAPI from "./exerciseVideo"
import ExerciseVideoWatchHistoryAPI from "./exerciseVideoWatchHistory"
import { DashboardAPI } from "./dashboard"
import AdminActionLogAPI from "./adminActionLog"
import NotificationTemplateAPI from "./notificationTemplate"
import PushCampaignAPI from "./pushCampaign"
import PushHistoryAPI from "./pushHistory"
import LegalTermsAPI from "./legalTerms"
import UserAgreementAPI from "./userAgreement"
import FaqAPI from "./faq"
import InquiryAPI from "./inquiry"

import { SmsApi } from "./sms"
import { GiftCategoryApi } from "./giftCategory"
import { GiftishowApi } from "./giftishow" // Added

import { SystemConfigApi } from "./systemConfig"
import SurgerySiteAPI from "./surgerySite"
import BodyPartAPI from "./bodyPart"
import AttendanceAPI from "./attendance"
import PointLimitPolicyAPI from "./pointLimitPolicy"
import AppVersionAPI from "./appVersion"

/**
 * 모든 API 그룹 통합
 */
const ApiRegistry = {
  Authentication: AuthenticationAPI,
  User: UserAPI,
  Tenant: TenantAPI,
  Advertiser: AdvertiserAPI,
  CommonCode: CommonCodeAPI,
  InterstitialAd: InterstitialAdAPI,
  LoginHistory: LoginHistoryAPI,
  Device: DeviceAPI,
  PointPolicy: PointPolicyAPI,
  StepRecord: StepRecordAPI,
  PointBalance: PointBalanceAPI,
  PointTransaction: PointTransactionAPI,
  PointUseRequest: PointUseRequestAPI,
  AdViewLog: AdViewLogAPI,
  UserPointLimitPolicy: UserPointLimitPolicyAPI,
  PointUsePolicy: PointUsePolicyAPI,
  ExerciseVideo: ExerciseVideoAPI,
  ExerciseVideoWatchHistory: ExerciseVideoWatchHistoryAPI,
  Dashboard: DashboardAPI,
  AdminActionLog: AdminActionLogAPI,
  NotificationTemplate: NotificationTemplateAPI,
  PushCampaign: PushCampaignAPI,
  PushHistory: PushHistoryAPI,
  LegalTerms: LegalTermsAPI,
  UserAgreement: UserAgreementAPI,
  Faq: FaqAPI,
  Inquiry: InquiryAPI,
  SystemConfig: SystemConfigApi,
  Sms: SmsApi,
  GiftCategory: GiftCategoryApi,
  Giftishow: GiftishowApi,
  SurgerySite: SurgerySiteAPI,
  BodyPart: BodyPartAPI,
  Attendance: AttendanceAPI,
  PointLimitPolicy: PointLimitPolicyAPI,
  AppVersion: AppVersionAPI,
}

export default ApiRegistry
